import { render, staticRenderFns } from "./StatementsReportUser.vue?vue&type=template&id=40609710"
import script from "./StatementsReportUser.vue?vue&type=script&lang=js"
export * from "./StatementsReportUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports